import React, { useEffect, useState } from "react";
import AnswerQueryModal from "@root/components/faq/AnswerQueryModal";
import PendingQnA from "@root/components/faq/pendingQnA";
import { Paginate } from "@root/components/pagination";
import { useInquiryContext } from "@root/context/inquiries";
import CustomSelect from "@root/components/common/CustomSelect";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";

const PendingQATab: React.FC = () => {
  const [answerModalOpen, setAnswerModalOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] =
    useState<PendingQuestion | null>(null);
  const [pendingOnlyStatus, setPendingOnlyStatus] = useState<boolean | null>(
    null
  );

  const { t } = useTranslation("common");

  const {
    fetchInquiry,
    InquiryData,
    pageCount,
    pageNo,
    setPageNo,
    pageSize,
    answerInquiry,
    answerInquiryLoading,
  } = useInquiryContext();

  const handleRespond = (id: string) => {
    const q = InquiryData?.find((q: { id: string }) => q.id === id);
    if (q) {
      setSelectedQuestion(q);
      setAnswerModalOpen(true);
    }
  };

  const handlePendingStatus = (value: boolean | null) => {
    setPendingOnlyStatus(value);
    setPageNo(1);
  };

  const filterOptions = [
    { label: t("faq.pending"), value: true },
    { label: t("faq.answered"), value: false },
  ];

  const handleSubmitAnswer = async (answer: string) => {
    if (!selectedQuestion?.id) return;

    try {
      await answerInquiry(selectedQuestion.id, answer);
      setAnswerModalOpen(false);
      setSelectedQuestion(null);
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };

  const handlePageChange = (newPage: number) => {
    setPageNo(newPage);
    const payload = {
      offset: (newPage - 1) * pageSize,
      limit: pageSize,
    };
    fetchInquiry(payload);
  };

  useEffect(() => {
    let payload: any = {
      offset: (pageNo - 1) * pageSize,
      limit: pageSize,
    };

    // Only add pendingOnly if it's explicitly true or false
    if (pendingOnlyStatus === true || pendingOnlyStatus === false) {
      payload.pendingOnly = pendingOnlyStatus;
    }

    fetchInquiry(payload);
  }, [pendingOnlyStatus, pageNo]);

  return (
    <>
      <Flex justifyContent={"flex-end"} m={4}>
        <CustomSelect
        borderRadius="12px"
        height="44px"
        placement="bottom-end"
        value={pendingOnlyStatus}
        onChange={(value: boolean | null) => handlePendingStatus(value)}
        placeholder={t("faq.pendingQuestions")}
        options={filterOptions}
      />
      </Flex>

      <PendingQnA
        questions={InquiryData ?? []}
        onRespond={handleRespond}
        isAnswering={answerInquiryLoading}
      />

      <AnswerQueryModal
        isOpen={answerModalOpen}
        onClose={() => setAnswerModalOpen(false)}
        question={selectedQuestion}
        onSubmit={handleSubmitAnswer}
        isLoading={answerInquiryLoading}
      />

      <Paginate
        page={pageNo}
        count={pageCount}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        margin={1}
        variant="ghost"
      />
    </>
  );
};

export default PendingQATab;
